module.exports = __webpack_public_path__ + "img/PH.33564a5b.png";